import type {PropsWithChildren} from 'react'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {useViewerRoles} from '../for-you/shared/use-viewer-roles'

/**
 * Resolves the viewer's roles (author / assignee / reviewer) and injects them as
 * snake_case metadata into every analytics event fired within the overview subtree
 * via `sendPullRequestAnalyticsEvent`.
 */
export function OverviewAnalyticsProvider({children}: PropsWithChildren) {
  const {isServer} = useRuntimeEnvironment()
  return isServer ? children : <ClientOverviewAnalyticsProvider>{children}</ClientOverviewAnalyticsProvider>
}

function ClientOverviewAnalyticsProvider({children}: PropsWithChildren) {
  const roles = useViewerRoles()

  if (roles.queryStatus !== 'success') return children

  return (
    <AnalyticsProvider
      appName="pull-requests"
      category="overview"
      metadata={{
        is_author: roles.isAuthor.toString(),
        is_assignee: roles.isAssignee.toString(),
        is_reviewer: roles.isReviewer.toString(),
      }}
    >
      {children}
    </AnalyticsProvider>
  )
}
